import { useEffect, useState } from 'react';

interface LoadScriptProps {
  src: string;
  isEnabled?: boolean;
}

export function useWootricLoadScript({ src, isEnabled }: LoadScriptProps) {
  const [scriptReady, setScriptReady] = useState(false);

  useEffect(() => {
    if (!isEnabled) return;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.async = true;
    script.onload = () => setScriptReady(true);
    document.body.appendChild(script);
    return () => script.remove();
  }, [src, isEnabled]);

  return { scriptReady };
}
